import "./ObjektKeyInfo.css";

export default function ObjektKeyInfo({
  id,
  nominalValue,
  currencyName,
  year,
  countryName,
  onClick
}) {
  return (
    <div className="objektkeyinfo-container" onClick={onClick}>
      <div className="objektkeyinfo-row">
        <span>ID</span>
        <button
          className="btn btn-link text-decoration-underline p-0 objektkeyinfo-link"
          onClick={(e) => {
            e.stopPropagation();   // verhindert, dass der Klick die Ansicht toggelt
            onClick(id, true);     // optional: zweiter Parameter für "Link-Klick"
          }}
        >
          {id}
        </button>
      </div>

      <div className="objektkeyinfo-row">
        <span>Nominal</span>
        <span>{nominalValue}</span>
      </div>

      <div className="objektkeyinfo-row">
        <span>Währung</span>
        <span>{currencyName}</span>
      </div>

      <div className="objektkeyinfo-row">
        <span>Land</span>
        <span>{countryName}</span>
      </div>

      <div className="objektkeyinfo-row">
        <span>Jahr</span>
        <span>{year}</span>
      </div>

    </div>
  );
}
